<template>
  <div>
    <div v-if="model.device_type === DefaultDeviceOptions.web.value" class="promo-design-group">
      <div class="promo-window-size-inputs">
        <v-select
          v-model="actions.rf_settings_window_max_width"
          :items="windowWidthOptions"
          persistentPlaceholder
          itemTitle="text"
          label="Window width"
          name="window-max-width"
          variant="outlined"
          required
          density="compact"
          hideDetails
        ></v-select>
        <v-text-field
          v-model.trim="actions.rf_settings_text_container_max_width"
          persistentPlaceholder
          hideDetails
          variant="outlined"
          density="compact"
          label="Message Width"
          required
        ></v-text-field>
      </div>
    </div>
    <div v-if="model.device_type !== DefaultDeviceOptions.web.value" class="promo-design-group">
      <div class="promo-window-size-inputs">
        <v-select
          v-if="showPopUpSize"
          v-model="actions.rf_settings_pop_up_size"
          :items="windowWidthOptions"
          persistentPlaceholder
          itemTitle="text"
          itemValue="textValue"
          label="Pop up size"
          name="window-max-width"
          variant="outlined"
          required
          density="compact"
          hideDetails
        ></v-select>
        <v-text-field
          v-model.trim="actions.rf_settings_text_container_max_width"
          persistentPlaceholder
          hideDetails
          variant="outlined"
          density="compact"
          label="Message Width"
          required
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script setup>
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";

defineProps({
  actions: { type: Object, default: null },
  model: { type: Object, default: null },
  showPopUpSize: { type: Boolean, default: false },
});

const windowWidthOptions = [
  { text: "Large", textValue: "large", value: "1200px" },
  { text: "Medium", textValue: "medium", value: "960px" },
  { text: "Small", textValue: "small", value: "750px" },
];
</script>
